module.exports = __webpack_public_path__ + "static/media/arkadip.0fd9aef4.jpeg";